import styled, { css } from "styled-components";
import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";

const fieldContainerStyle = css`
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
	border-right: 0px;
	padding: 10px;
`;

const CodeWrapper = styled.div`
	padding: 8px 10px;
	border-radius: ${BorderRadius.LG}px;
	background-color: ${BackgroundColors.Primary};
	width: fit-content;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid ${BackgroundColors.BluePrimary};
	margin-bottom: 16px;
`;

export { fieldContainerStyle, CodeWrapper };
